<template lang="pug">
    div.radio-select-field.form-group(:class='theClass')
        label(v-if='label') {{ label }}

        div.radio-select-field__options
            div.radio-select-field__container(v-for='(option, idx) in options')
                div.radio-select-field__option-outline(v-if='checkOutlineSlot(option.value)')
                    slot(:name='getOutlineSlotName(option.value)')

                div.radio-select-field__option(:class='getOptionClass(option)' @click='select(option.value, idx)')
                    div.radio-select-field__radio
                        div.radio-select-field__radio-mark
                            svg-icon(iconId='checkbox-check')
                    div.radio-select-field__label {{ option.label }}

                div.radio-select-field__option-content(v-if='checkContentSlot(option.value)' :class='getContentClass(option, stateUpdateIdx)' :style='getContentStyle(option, stateUpdateIdx)')
                    div.radio-select-field__option-content-ph(ref='contents')
                        div
                            slot(:name='getContentSlotName(option.value)')
</template>

<script>
import $ from 'jquery'
import _ from 'lodash'

export default {
    name: 'radio-select-field',
    props: {
        value: {
            validator: v => !v || typeof(v) == 'string' || typeof(v) == 'number'
        },
        label: String,
        options: {
            type: Array,
            required: true,
        },
        mode: {
            type: String,
        },
        allowUnselect: {
            type: Boolean,
        },
    },
    data() {
        return {
            contentStates: {},
            contentHeights: {},
            stateUpdateIdx: 0,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },

        modeCompact() {
            return this.mode == 'compact'
        },
        modeGrid() {
            return this.mode == 'grid'
        },

        theClass() {
            return `radio-select-field--mode-${this.mode ? this.mode : 'default'}`
        },
    },
    watch: {
        model(val, old) {
            this.switchContent(val, old)
        },
    },
    methods: {
        select(value) {
            if (this.allowUnselect && this.model === value) {
                this.model = null
            }
            else {
                this.model = value
            }
        },

        checkSelected(option) {
            return option.value === this.model
        },

        getOptionClass(option) {
            return {
                'radio-select-field__option--selected': this.checkSelected(option),
            }
        },

        getContentClass(option) {
            const state = this.contentStates[option.value] || 'close'
            return `radio-select-field__option-content--${state}`
        },
        getContentStyle(option) {
            const height = this.contentHeights[option.value]
            if (height) {
                return {
                    'height': `${height}px`,
                }
            }
        },

        getContentSlotName(value) {
            return `option-content-${value}`
        },
        checkContentSlot(value) {
            const slotName = this.getContentSlotName(value)
            return !!this.$slots[slotName]
        },

        getOutlineSlotName(value) {
            return `option-outline-${value}`
        },
        checkOutlineSlot(value) {
            const slotName = this.getOutlineSlotName(value)
            return !!this.$slots[slotName]
        },

        switchContent(val, oldVal, immediate) {
            const valSlot = this.checkContentSlot(val)
            const oldValSlot = this.checkContentSlot(oldVal)

            if (oldValSlot) {
                this.contentHeights[oldVal] = this.determineContentHeight(oldVal)
                this.stateUpdateIdx++
            }

            this.$nextTick(() => {
                if (valSlot) {
                    if (immediate) {
                        this.contentOpen(val)
                    }
                    else {
                        this.contentStates[val] = 'opening'
                        this.contentHeights[val] = this.determineContentHeight(val)
                        this.debounceContentOpen(val)
                    }
                }
                if (oldValSlot) {
                    this.contentStates[oldVal] = 'close'
                    this.contentHeights[oldVal] = null
                }
                this.stateUpdateIdx++
            })
        },
        contentOpen(val) {
            this.contentStates[val] = 'open'
            this.contentHeights[val] = null
            this.stateUpdateIdx++
        },

        determineContentHeight(value) {
            const idx = this.options.findIndex(o => o.value === value)
            const el = this.$refs.contents[idx]
            return $(el).outerHeight(true)
        },
    },
    created() {
        this.debounceContentOpen = _.debounce(this.contentOpen, 250)
    },
    mounted() {
        this.switchContent(this.model, null, true)
    },
}
</script>
